/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 7.AR */
export const template7 = {
  title: t.to('AR', 'title7'),
  desc: t.to(
    'ARを使うには、シーンにARの設定用属性をつけます。ARマーカーの子要素として物体を配置するとマーカーに反応してカメラ上に登場します。',
    'desc7'
  ),
  img: '../public/template/7.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="50" y="110">
    <value name="ATTR">
      <block type="ar_scene_setting_attribute_v2">
        <field name="debugUIEnabled">false</field>
      </block>
    </value>
    <statement name="IN">
      <block type="ar_marker_v2">
        <value name="ATTR">
          <block type="ar_hiro_attribute_v2">
          </block>
        </value>
        <statement name="IN">
          <block type="sphere_v2">
            <field name="id">block1</field>
            <field name="position-x">0</field>
            <field name="position-y">0</field>
            <field name="position-z">0</field>
            <value name="COLOUR">
              <shadow type="color_value_v2">
                <field name="COLOUR">#ff0000</field>
              </shadow>
            </value>
          </block>
        </statement>
      </block>
    </statement>
  </block>
</xml>
`,
};
